import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const receivedOrderSlice = createSlice({
  name: "receivedOrder",

  initialState: {
    receivedOrderData: [],
    isError2: false,
  },

  reducers: {
    fetchOrderSuccess: (state, action) => {
      state.isError2 = false;
      state.receivedOrderData = action.payload;
    },
    fetchOrderFail: (state) => {
      state.isError2 = true;
    },
    resetState: (state) => {
      state.receivedOrderData = [];
      state.isError2 = false;
    },
  },
});

export const { fetchOrderSuccess, fetchOrderFail, resetState } =
  receivedOrderSlice.actions;

export const fetchReceivedOrder = (logout) => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/seller/order`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: config.token,
        Accept: "application/json",
      },
    });
    dispatch(fetchOrderSuccess(response.data.data));
  } catch (error) {
    dispatch(fetchOrderFail());
    if (error.response && error.response.status === 401) {
      logout();
    }
  }
};
export default receivedOrderSlice.reducer;
